const availableIntervals = {
  weekly: { value: 7, label: 'Weekly', type: 'weeks' },
  monthly: { value: 30, label: 'Monthly', type: 'months' },
}

export default function getSmokeScoreboardConstants() {
  return { availableIntervals }
}
